var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_help_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2.66659C5.05513 2.66659 2.66732 5.0544 2.66732 7.99992C2.66732 10.9454 5.05513 13.3333 8.00065 13.3333C10.9462 13.3333 13.334 10.9454 13.334 7.99992C13.334 5.0544 10.9462 2.66659 8.00065 2.66659ZM1.33398 7.99992C1.33398 4.31802 4.31875 1.33325 8.00065 1.33325C11.6826 1.33325 14.6673 4.31802 14.6673 7.99992C14.6673 11.6818 11.6826 14.6666 8.00065 14.6666C4.31875 14.6666 1.33398 11.6818 1.33398 7.99992Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 10.6667C8.36884 10.6667 8.66732 10.9652 8.66732 11.3334V11.3401C8.66732 11.7083 8.36884 12.0067 8.00065 12.0067C7.63246 12.0067 7.33398 11.7083 7.33398 11.3401V11.3334C7.33398 10.9652 7.63246 10.6667 8.00065 10.6667Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98298 4.22988C7.31592 4.06515 7.68255 3.97994 8.05401 3.98097C8.42548 3.982 8.79163 4.06924 9.12364 4.23582C9.45566 4.40241 9.74448 4.64379 9.96736 4.94096C10.1902 5.23813 10.3411 5.58298 10.408 5.94836C10.475 6.31374 10.4562 6.68967 10.3532 7.04656C10.2502 7.40346 10.0657 7.73156 9.81436 8.00505C9.56299 8.27855 9.25156 8.48995 8.9046 8.62264C8.89898 8.62479 8.89332 8.62687 8.88763 8.62886C8.81947 8.65283 8.76094 8.6983 8.72086 8.75842C8.68078 8.81854 8.66132 8.89006 8.66541 8.9622L8.70316 9.62779L7.37197 9.70329L7.33422 9.0377C7.31376 8.677 7.41106 8.31942 7.61146 8.01882C7.80978 7.72134 8.09844 7.4956 8.43473 7.3748C8.58638 7.31569 8.72251 7.22265 8.83269 7.10278C8.94441 6.98123 9.02639 6.8354 9.07218 6.67678C9.11797 6.51816 9.12631 6.35108 9.09655 6.18869C9.06679 6.0263 8.99975 5.87303 8.90069 5.74096C8.80163 5.60888 8.67327 5.5016 8.52571 5.42756C8.37814 5.35353 8.21541 5.31475 8.05032 5.31429C7.88522 5.31384 7.72227 5.35171 7.5743 5.42493C7.42633 5.49814 7.29737 5.60471 7.19759 5.73623L6.79463 6.26734L5.73242 5.46143L6.13537 4.93033C6.3599 4.6344 6.65005 4.39462 6.98298 4.22988Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledQuestionMark);
export default __webpack_public_path__ + "static/media/circled-question-mark.e3df3d81283ac188ac99f2000fcadd75.svg";
export { ForwardRef as ReactComponent };